import React, { useEffect, useRef, useState } from 'react';
import { WaIcon } from './Header';
import { trackWhatsAppClick } from '../analytics';
import { CHAT_RESPUESTAS, CHAT_CLAVES, CHAT_CHIPS, WHATSAPP } from '../mock';

const ChatWidget = () => {
  const [abierto, setAbierto] = useState(false);
  const [mensajes, setMensajes] = useState([]);
  const [texto, setTexto] = useState('');
  const msgsRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (msgsRef.current) msgsRef.current.scrollTop = msgsRef.current.scrollHeight;
  }, [mensajes]);

  const poner = (msg) => setMensajes((m) => [...m, msg]);

  const responder = (q) => {
    const t = q.toLowerCase();
    for (const [claves, key] of CHAT_CLAVES) {
      for (const c of claves) {
        if (t.indexOf(c) !== -1) {
          poner({ quien: 'bot', texto: CHAT_RESPUESTAS[key] });
          return;
        }
      }
    }
    poner({ quien: 'bot', tipo: 'wa', texto: 'Buena pregunta — mejor te la responde una persona del equipo.', waHref: `https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hola, tengo una pregunta: ' + q)}` });
  };

  const enviar = () => {
    const q = texto.trim();
    if (!q) return;
    poner({ quien: 'yo', texto: q });
    setTexto('');
    setTimeout(() => responder(q), 250);
  };

  const abrir = () => {
    setAbierto(true);
    setMensajes((m) => (m.length === 0 ? [{ quien: 'bot', texto: CHAT_RESPUESTAS.hola }] : m));
    setTimeout(() => inputRef.current && inputRef.current.focus(), 50);
  };

  const chip = (c) => {
    poner({ quien: 'yo', texto: c.label });
    setTimeout(() => poner({ quien: 'bot', texto: CHAT_RESPUESTAS[c.q] }), 250);
  };

  return (
    <>
      {!abierto && (
        <button className="chat-fab" aria-expanded={abierto} aria-controls="chat-box" onClick={abrir} data-testid="chat-fab">
          💬 ¿Preguntas?
        </button>
      )}
      {abierto && (
        <div className="chat-box" id="chat-box" role="dialog" aria-label="Chat de preguntas frecuentes">
          <div className="chat-head">
            <div><strong>Finca Pescado</strong><small>Respuestas al instante</small></div>
            <button aria-label="Cerrar chat" onClick={() => setAbierto(false)}>×</button>
          </div>
          <div className="chat-msgs" ref={msgsRef}>
            {mensajes.map((m, i) => (
              <div className={`msg ${m.quien}`} key={i}>
                {m.texto}
                {m.tipo === 'wa' && (
                  <>
                    {' '}
                    <a href={m.waHref} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsAppClick('chat')}>Continuar en WhatsApp →</a>
                  </>
                )}
              </div>
            ))}
          </div>
          <div className="chat-chips">
            {CHAT_CHIPS.map((c) => (
              <button key={c.q} onClick={() => chip(c)}>{c.label}</button>
            ))}
          </div>
          <div className="chat-in">
            <input
              ref={inputRef}
              placeholder="Escribe tu pregunta..."
              aria-label="Tu pregunta"
              value={texto}
              onChange={(e) => setTexto(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && enviar()}
            />
            <button aria-label="Enviar" onClick={enviar}>➤</button>
          </div>
        </div>
      )}
      <a
        className="wa-float"
        href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hola Finca Pescado, quiero pedir cachama fresca')}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chatear por WhatsApp"
        onClick={() => trackWhatsAppClick('flotante')}
      >
        <WaIcon className="" />
      </a>
    </>
  );
};

export default ChatWidget;